/**
 * Save schema migrations.
 *
 * This ships from the first commit even though the table is empty. Adding it
 * after launch means guessing at the shape of saves already in the wild.
 *
 * Each migration takes the raw parsed save at version N, returns it at N+1,
 * and is responsible for setting `version` on the way out.
 */

export const CURRENT_VERSION = 1;

export type Migration = (s: any) => any;

export const migrations: Record<number, Migration> = {
  // 1: (s) => { ...; s.version = 2; return s; },
};

/** Walks a raw parsed save up to CURRENT_VERSION. Throws if it cannot. */
export function migrate(raw: any): any {
  if (raw === null || typeof raw !== 'object') {
    throw new Error('Save is not an object');
  }

  let s = raw;
  let version = typeof s.version === 'number' ? s.version : NaN;

  if (!Number.isFinite(version)) {
    throw new Error('Save has no version');
  }
  if (version > CURRENT_VERSION) {
    throw new Error(`Save version ${version} is newer than this build (${CURRENT_VERSION})`);
  }

  while (version < CURRENT_VERSION) {
    const step = migrations[version];
    if (step === undefined) {
      throw new Error(`No migration path from save version ${version}`);
    }
    s = step(s);
    const next = typeof s.version === 'number' ? s.version : NaN;
    if (!(next > version)) {
      throw new Error(`Migration from version ${version} did not advance the version`);
    }
    version = next;
  }

  return s;
}
